<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isSysAdmin()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Branches | Master</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-lg-12">
<div class="col-lg-10 center center-block" align="center">
	<div class="card card-danger card-outline">
		<div class="card-header">
			<button @click="sync" class="btn btn-danger float-right">Sync Branches</button>
		</div>
		<div class="card-body overflow-auto">
			<div class="col-md-12 float-left">
			<div class="row">
				<div class="col-sm-4 float-left">
      		<div class="form-group">
      			<input type="number" class="form-control" min="5" value="10" v-model="results" placeholder=" Enter No. of results" @input="getBranches('/api/getBranches')">
      		</div>
			  </div>
			  <div class="col-sm-4">
      		<div class="form-group">
      			<v-select v-model="branch" class="form-control" type="text" label="BRANCH_NAME" :options="branches" :reduce="branches => branches.BRANCH_CODE" name="branch" placeholder="Select Branch" :value="branches => branches.BRANCH_CODE"></v-select>
      		</div>
				</div>
		<div class="col-sm-4">
      		<div class="form-group float-left">
      			<input type="text" class="form-control" v-model="city" placeholder=" Enter a city">
      		</div>
		</div>
		<div class="col-sm-4"> 
      		<div class="form-group float-left">
      			<button class="btn btn-danger" @click="getBranches('/api/getBranches')"><i class="fa fa-search"></i> Search</button>
      		</div>
      	</div>
      	
		<div class="col-sm-4">   		
      		<div class="form-group float-left">
      			<button class="btn btn-danger" @click="reset"><i class="fa fa-times"></i> Reset</button>
      		</div>
      	</div>
      	
		<div class="col-sm-4"> 
      		<div class="form-group float-left">
      			<button class="btn btn-secondary" @click="excel"><i class="fa fa-print"></i> Generate Excel</button>
      		</div>
      	</div>
      </div>
      </div>
      <img v-if="branches==''" src=""/>
			<datatable style="margin-top:1%;" :columns="columns" v-else>
				<tbody>
					<tr v-for="branch in branches" :key="branch.id">
						<td>{{branch.BRANCH_NAME}}</td>
						<td>{{branch.BRANCH_CODE}}</td>
						<td>{{branch.BRANCH_GSTIN}}</td>
						<td><button class="btn btn-danger" @click="view(branch)"><i class="fa fa-eye"></i> View More</button></td>
					</tr>
				</tbody>
			</datatable>
			<!-- content here -->

    </div>
    <div class="card-footer">
    	<pagination :pagination="pagination"
       	@prev="getBranches(pagination.prevPageUrl)"
        @next="getBranches(pagination.nextPageUrl)"
      ></pagination>
		</div>
	</div>
</div>
</div>
<!-- row end -->
    </section>
    <!-- /.content -->
<div class="modal" tabindex="-1" role="dialog" id="viewModal">
 <div class="modal-dialog" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">Branch Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						<p><b>Name:</b> {{form.BRANCH_NAME}}</p>
						<p><b>Code:</b> {{form.BRANCH_CODE}}</p>
						<p><b>Address Line 1:</b> {{form.BRANCH_ADDLINE1}}</p>
						<p><b>Address Line 2:</b> {{form.BRANCH_ADDLINE2}}</p>
						<p><b>Address Line 3:</b> {{form.BRANCH_ADDLINE3}}</p>
						<p><b>Pincode:</b> {{form.BRANCH_PINCODE}}</p>
						<p><b>City:</b> {{form.BRANCH_CITY}}</p>
						<p><b>State:</b> {{form.BRANCH_STATE}}</p>
						<p><b>GSTIN:</b> {{form.BRANCH_GSTIN}}</p>
						<p><b>Phone:</b> {{form.BRANCH_PHONE}}</p>
						<p><b>Email:</b> {{form.BRANCH_EMAIL}}</p>
						<p><b>Opened On:</b> {{form.BRANCH_OPENEDON}}</p>
						<p><b>Status:</b> {{form.BRANCH_STATUS}}</p>
						<p><b>Category:</b> {{form.BRANCH_CATEGORY}}</p>
						<p><b>CLS 01:</b> {{form.BRANCH_CLS_01}}</p>
						<p><b>CLS 02:</b> {{form.BRANCH_CLS_02}}</p>
						<p><b>CLS 03:</b> {{form.BRANCH_CLS_03}}</p>
						<p><b>CLS 04:</b> {{form.BRANCH_CLS_04}}</p>
						<p><b>CLS 05:</b> {{form.BRANCH_CLS_05}}</p>
						<p><b>CLS 06:</b> {{form.BRANCH_CLS_06}}</p>
						<p><b>CLS 07:</b> {{form.BRANCH_CLS_07}}</p>
						<p><b>CLS 08:</b> {{form.BRANCH_CLS_08}}</p>
						<p><b>CLS 09:</b> {{form.BRANCH_CLS_09}}</p>
						<p><b>CLS 10:</b> {{form.BRANCH_CLS_10}}</p>
					</div>
					<div class="card-footer">
					<button class="btn btn-secondary" data-dismiss="modal">Close</button>
				</div>
				</div>
				</div>
				</div>
 <loading
     :show="lshow"
     :label="llabel">
 </loading>
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSysAdmin()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		import Datatable from '../../datatable.vue';
    import Pagination from '../../pagination.vue';
    import { saveAs } from 'file-saver';
    import loading from 'vue-full-loading';
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        components: {datatable:Datatable, pagination:Pagination, loading},
        
        created(){
        	this.getBranches();
        },
        
        data(){
        	let columns = [
      			{width:'25%', label:'Name', name:'BRANCH_NAME'},
      			{width:'25%', label:'Code', name:'BRANCH_CODE'},
      			{width:'25%', label:'GSTIN', name:'BRANCH_GSTIN'},
      			{width:'25%', label:'View More', name:'ops'},
      		];
      		
      		return {
      			columns: columns,
      			pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		branches: [],
         		results: '',
         		branch: '',
         		city: '',
         		form: new Form({
         			BRANCH_NAME: '',
            	BRANCH_CODE: '',
            	BRANCH_ADDLINE1: '',
            	BRANCH_ADDLINE2: '',
            	BRANCH_ADDLINE3: '',
            	BRANCH_PINCODE: '',
            	BRANCH_CITY: '',
            	BRANCH_STATE: '',
            	BRANCH_GSTIN: '',
            	BRANCH_PHONE: '',
            	BRANCH_EMAIL: '',
            	BRANCH_OPENEDON: '',
            	BRANCH_STATUS: '',
            	BRANCH_CATEGORY: '',
            	BRANCH_CLS_01: '',
            	BRANCH_CLS_02: '',
            	BRANCH_CLS_03: '',
            	BRANCH_CLS_04: '',
            	BRANCH_CLS_05: '',
            	BRANCH_CLS_06: '',
            	BRANCH_CLS_07: '',
            	BRANCH_CLS_08: '',
            	BRANCH_CLS_09: '',
            	BRANCH_CLS_10: ''
         		}),
         		lshow: false,
           	llabel: 'Syncing. Do not close or change this page...'
      		}
        },
        
        methods: {
        	configPagination(data){
      		this.pagination.lastPage=data.lastPage;
         	this.pagination.currentPage=data.current_page;
    	  	this.pagination.total=data.total;
        	this.pagination.lastPageUrl=data.last_page_url;
       		this.pagination.nextPageUrl=data.next_page_url;
       		this.pagination.prevPageUrl=data.prev_page_url;
     		 	this.pagination.from=data.from;
        	this.pagination.to=data.to;
    		},
    		
        	getBranches(url="/api/getBranches"){
        		axios.post(url, {results: this.results, branch: this.branch, city: this.city})
        		.then(response => {
        			this.branches = response.data.data.data;
        			this.configPagination(response.data.data);
        		})
        	},
        	
        	view(branch){
        		this.form.fill(branch);
        		$("#viewModal").modal("show");
        	},
        	
        	excel(){
        		axios({
        		url: "/api/branchesExcel", 
        		data: {city: this.city},
        		method: 'post',
        		responseType: 'blob'
        		})
        		.then(response => {
        			toast.fire({
        				icon: 'success',
        				title: 'Report Generated'
        			})
        			var blob = new Blob ([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        			if(this.city != '')
        				saveAs(response.data, this.city+"_branches.xlsx");
        			else
        				saveAs(response.data, "branches.xlsx");
        		})
        	},
        	
        	sync(){
        		toast.fire({
        			icon: 'warning',
        			title: 'Wait For Syncing to be Over'
        		})
        		this.lshow = true;
        		axios.post("/api/syncBranches")
        		.then(response => {
        			toast.fire({
        				title: response.data+" Items Synced",
        				type: "success"
        			});
        			this.getBranches();
        			this.lshow = false;
        		})
        		.catch(() => {
        			toast.fire({
        				title: "Syncing Failed! Try Again.",
        				type: "error"
        			});
        			this.lshow = false;
        		})
        	},
        	
        	reset(){
        		this.results = '';
        		this.branch = '';
        		this.city = '';
        	}
        }
    }
</script>
